import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReportService } from 'src/app/shared/services/report/report.service';
import { Reports, ReportTypeEnum } from 'src/app/shared/util/reports';
import { Utilities } from 'src/app/shared/util/utilities';
import { TranslateService } from '@ngx-translate/core';
import { ContactUs } from 'src/app/shared/services/contact-us/contact-us';
import { TrackerService } from 'src/app/services/tracker.service';
import { ErrorComponent, Helpers, InformationComponent } from 'src/app/shared/util/helpers';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { ContactUsService } from 'src/app/shared/services/contact-us/contact-us.service';
import { HostListener } from '@angular/core';
import { DocumentPriceEnum, DOCUMENT_PRICES } from 'src/app/shared/util/document-prices.enum';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pricing',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit {
  public contactItem: ContactUs = new ContactUs();
  isDropdownOpen = false;
  activeDropdownId: string | null = null;
  documentPrices = DOCUMENT_PRICES;

  constructor(
    public snackBar: MatSnackBar,
    private router: Router,
    private trackerService: TrackerService,
    private reportService: ReportService,
    public contactUsService: ContactUsService,
    public translate: TranslateService
  ) { }

  ngOnInit(): void {
  }

  redirectToPayment(documentUniqueName: string) {
    // Caută obiectul din DOCUMENT_PRICES cu documentUniqueName exact
    const priceDetails = Object.values(DOCUMENT_PRICES).find(
      doc => doc.documentUniqueName.toLowerCase() === documentUniqueName.toLowerCase()
    );

    // Check if user is authenticated
    const token = localStorage.getItem('id_token');

    if (!token) {
      // Save requested document information to localStorage
      localStorage.setItem('pendingDocument', JSON.stringify({
        documentFormat: priceDetails.documentFormat,
        documentUniqueName: priceDetails.documentUniqueName,
        documentUniqueGroup: priceDetails.documentUniqueGroup,
        documentType: priceDetails.documentType,
        documentPrice: priceDetails.documentPrice,
        documentCurrency: priceDetails.documentCurrency,
      }));

      // Redirect to login page with return URL
      this.router.navigate(['/login'], {
        queryParams: {
          returnUrl: '/documents'
        }
      });

      // Show message about login requirement
      this.snackBar.open(
        'You need to log in to download documents',
        'Close',
        { duration: 5000 }
      );

      return;
    }

    // Always go to card-payment, but pass a flag for free documents
    this.router.navigate(['/card-payment'], {
      queryParams: {
        documentFormat: priceDetails.documentFormat,
        documentUniqueName: priceDetails.documentUniqueName,
        documentUniqueGroup: priceDetails.documentUniqueGroup,
        documentType: priceDetails.documentType,
        documentPrice: priceDetails.documentPrice,
        documentCurrency: priceDetails.documentCurrency,
      }
    });
  }

  // downloadDocument(format: string = 'pdf', documentType: string) {
  //   // This is a placeholder. You'll need to implement the actual download logic
  //   console.log(`Attempting to download ${documentType} in ${format} format`);

  //   // Example: You might want to call a service method to generate and download the document
  //   // this.reportService.downloadDocument(documentType, format);

  //   // Show a success message
  //   this.snackBar.open(
  //     `Downloaded ${documentType} document in ${format} format`, 
  //     'Close', 
  //     { duration: 3000 }
  //   );
  // }

  // private generateReport(reportType: ReportTypeEnum, dataType: any, format: string = 'pdf') {
  //   console.group('Generating Report');
  //   console.log('Report Details:', { 
  //     reportType, 
  //     dataType, 
  //     format,
  //     dataTypeKeys: Object.keys(dataType || {})
  //   });

  //   // Validate input
  //   if (!reportType) {
  //     console.error('Report type is required');
  //     this.snackBar.open('Invalid report type', 'Close', { duration: 3000 });
  //     return;
  //   }

  //   this.reportService.getPDFFile(reportType, dataType, format).subscribe(
  //     param => {
  //       console.log('Report Service Response:', param);

  //       try {
  //         let jsonResponse = JSON.parse(JSON.stringify(param));
  //         console.log('Parsed JSON Response:', jsonResponse);

  //         if (jsonResponse && jsonResponse['message'] === 'OK') {
  //           console.log('Attempting to download file');
  //           this.downloadFile(Utilities.dataURItoBlob(jsonResponse['content']), format);
  //         } else {
  //           console.error('Report generation failed', { 
  //             message: jsonResponse ? jsonResponse['message'] : 'No message', 
  //             response: jsonResponse 
  //           });
  //           this.snackBar.open('Failed to generate document. Please try again.', 'Close', {
  //             duration: 3000
  //           });
  //         }
  //       } catch (parseError) {
  //         console.error('Error parsing response:', parseError);
  //         this.snackBar.open('Error processing document. Please contact support.', 'Close', {
  //           duration: 3000
  //         });
  //       }
  //     },
  //     error => {
  //       console.error('HTTP Error in report generation:', error);
  //       this.snackBar.open('Failed to generate document. Please check your connection.', 'Close', {
  //         duration: 3000
  //       });
  //     },
  //     () => {
  //       console.log('Report generation observable completed');
  //       console.groupEnd();
  //     }
  //   );
  // }

  // private downloadFile(blob: Blob, format: string = 'pdf') {
  //   try {
  //     console.log('Downloading file', { 
  //       blobSize: blob.size, 
  //       type: blob.type 
  //     });

  //     const dataURL = window.URL.createObjectURL(blob);
  //     const link = document.createElement('a');
  //     link.href = dataURL;
  //     link.download = `document.${format}`;

  //     // Append to body, click, and remove
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);

  //     setTimeout(() => {
  //       window.URL.revokeObjectURL(dataURL);
  //     }, 100);
  //   } catch (downloadError) {
  //     console.error('Error downloading file:', downloadError);
  //     this.snackBar.open('Error downloading document. Please try again.', 'Close', {
  //       duration: 3000
  //     });
  //   }
  // }

  send(): void {
    this.contactItem.date = new Date();

    Helpers.getObservable([])
      .pipe(
        switchMap(() => this.contactUsService.addItem(this.contactItem)),
        catchError(
          error => {
            throw error;
          }
        ),
        finalize(() => {
        }),
      )
      .subscribe(
        results => {
          this.contactItem.subject = '';
          this.contactItem.content = '';

          this.snackBar.openFromComponent(InformationComponent, {
            duration: 2000,
          });
        },
        error => {
          this.snackBar.openFromComponent(ErrorComponent, {
            duration: 2000,
          });
        }
      );
  }

  toggleDropdown(event: Event, id: string) {
    event.stopPropagation();
    if (this.activeDropdownId === id) {
      this.activeDropdownId = null;
    } else {
      this.activeDropdownId = id;
    }
  }

  @HostListener('document:click')
  closeDropdown() {
    this.activeDropdownId = null;
  }

  // Method to get price details for a specific document and format
  getDocumentPriceDetails(documentUniqueName: string, format: string) {
    const documentKey = Object.keys(this.documentPrices).find(key =>
      key.toLowerCase().includes(documentUniqueName.toLowerCase()) &&
      key.toLowerCase().includes(format.toLowerCase())
    );

    return documentKey ? this.documentPrices[documentKey as DocumentPriceEnum] : null;
  }

  getDocumentWidgetPrice(documentUniqueGroup: string): { price: number, currency: string } {
    // Extrage toate valorile obiectului documentPrices
    const allPrices = Object.values(this.documentPrices);

    // Filtrează după documentUniqueGroup
    const matchingDocuments = allPrices.filter(doc =>
      doc.documentUniqueGroup.toLowerCase() === documentUniqueGroup.toLowerCase()
    );

    // Dacă nu există documente pentru acel grup, returnează default
    if (matchingDocuments.length === 0) {
      console.warn(`No documents found for group: ${documentUniqueGroup}`);
      return { price: 0, currency: 'RON' };
    }

    // Dacă nu, returnează cel mai ieftin
    const cheapest = matchingDocuments.reduce((min, current) =>
      current.documentPrice < min.documentPrice ? current : min
    );

    return { price: cheapest.documentPrice, currency: cheapest.documentCurrency };
  }

  // Method to handle widget click
  onWidgetClick(documentUniqueGroup: string) {
    console.log('onWidgetClick', documentUniqueGroup);
    // Open dropdown instead of directly redirecting
    this.toggleDropdown(new Event('click'), documentUniqueGroup);
  }
}
